import React from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { CSVLink } from 'react-csv'

interface IReverificationUsersModal {
    show: any,
    handleClose: any
    tableData?: any[]
    label: string
}

export default function CollegeStatsModal(props: IReverificationUsersModal) {

    // Prepare CSV headers
    const headers = [
        { label: "S.No", key: "sno" },
        { label: "College ID", key: "collegeId" },
        { label: "College Name", key: "collegeName" }
    ];

    // Map tableData into CSV friendly format
    const csvData = props.tableData?.map((item, index) => ({
        sno: index + 1,
        collegeId: item.collegeId,
        collegeName: item.collegeName
    })) || [];

    return (
        <Modal
            show={!!props.show}
            onHide={props.handleClose}
            size="xl"
            animation={true}
            backdrop="static"
            centered
        >
            <Modal.Header>
                <div className="d-flex justify-content-between w-100">
                    <h5 className="mb-0">College {props.label} Statistics</h5>
                    {props.tableData && props.tableData.length > 0 && (
                        <CSVLink
                            data={csvData}
                            headers={headers}
                            filename="college_stats.csv"
                            className="btn btn-success btn-sm"
                        >
                            Export CSV
                        </CSVLink>
                    )}
                </div>
            </Modal.Header>

            <Modal.Body>
                <Table striped hover responsive>
                    <thead>
                        <tr>
                            <th style={{ fontSize: 14 }}>S.No</th>
                            <th style={{ fontSize: 14 }}>College ID</th>
                            <th style={{ fontSize: 14 }}>College Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.tableData?.map((item: any, index: number) => (
                            <tr key={index}>
                                <td style={{ fontSize: 14 }}>{index + 1}</td>
                                <td style={{ fontSize: 14 }}>{item.collegeId}</td>
                                <td style={{ fontSize: 14 }}>{item.collegeName}</td>
                            </tr>
                        ))}
                        {props.tableData?.length === 0 && (
                            <tr>
                                <td colSpan={3} className="text-center" style={{ fontSize: 14 }}>
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
